import {
    Table,
    TableContainer,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@material-ui/core';
import React from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import WidgetCard from './WidgetCard';
import {useHistory} from 'react-router-dom';
import content from 'components/widgets/tooltips/InfoModalContent';

const useStyles = makeStyles(theme => ({
    table: {
        border: `1px solid ${theme.palette.gray.light}`,
    },
    typography: {
        color: theme.palette.text.primary,
    },
    typographySpan: {
        fontWeight: 'bold',
    },
    tableCell: {
        paddingRight: '.5rem',
        paddingLeft: '.5rem',
    },
}));

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.type === 'dark' ? theme.palette.gray.light2: theme.palette.primary.light4,
        },
        '&:hover': {
            backgroundColor: theme.palette.type === 'dark' ? theme.palette.primary.light : theme.palette.primary.light3,
            cursor: 'pointer',
        },
        '& td a': {
            textDecoration: 'none',
        },
    },
}))(TableRow);

const allFormsSummarySort = data => {
    // Will make most recent entry the first element of output array
    // Earliest entry will be last element of output array
    let output = data;

    output?.sort((elem1, elem2) => {
        if (elem1.date_detached > elem2.date_detached) {
            return -1;
        }
        if (elem1.date_detached < elem2.date_detached) {
            return 1;
        }
        return 0;
    });
    return output;
};

const SeaServiceRecords = props => {
    const data = allFormsSummarySort(props.data);
    const classes = useStyles();
    const history = useHistory();

    function ColumnHeaders() {
        const column_names = [
            'Vessel Name',
            'Date Detached',
            'Sea Service Credit',
        ];
        return column_names.map(name => (
            <TableCell className={classes.tableCell} key={name}>
                <Typography variant='body1'>{name}</Typography>
            </TableCell>
        ));
    }

    const navigate = pathname => {
        history.push(pathname);
    };

    return (
        <WidgetCard
            title='Sea Service Records'
            infoModalContent={content.records}
        >
            <TableContainer>
                <Table
                    aria-label='Sea Service Records Table'
                    className={classes.table}
                >
                    <TableHead>
                        <TableRow>
                            <ColumnHeaders />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map((row, index) => (
                            <StyledTableRow
                                hover
                                key={index}
                                onClick={() =>
                                    navigate(
                                        row.user_document_id
                                            ? `/document/${row?.document_type}/${row?.id}`
                                            : '#'
                                    )
                                }
                            >
                                <TableCell className={classes.tableCell}>
                                    {row.vessel_name}
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    {row.date_detached}
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    {' '}
                                    {parseInt(
                                        row.total_number_days_credit * 10
                                    ) / 10}
                                    {` Days ${row.watertype ? ` - ${row.watertype}` : ''}`}
                                </TableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </WidgetCard>
    );
};

export default SeaServiceRecords;
